import { createUseStyles } from '@pff-consumer/tweed-ui/styles/create-use-styles'
import { ViewStyle } from 'react-native'

interface MissingEspnSecretsErrorStyles {
  espnContainer: ViewStyle
}

const CONTAINER_MAX_WIDTH = 295

export const useStyles = createUseStyles<MissingEspnSecretsErrorStyles>((theme) => {
  return {
    espnContainer: {
      maxWidth: theme.calcUnit(CONTAINER_MAX_WIDTH),
      margin: 'auto',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      gap: theme.calcUnit(theme.spacing.s6),
      marginBottom: theme.calcUnit(theme.spacing.s6),
    },
  }
})
